import React from "react";
import { useNavigate } from "react-router-dom";

import { BUSINESS_VERTICAL, ORDER_STATUSES } from "constants/config";
import { PrimaryButton, SecondaryButton } from "widgets";
import { useCallCustomer } from "store/backend/assets";
import Loader from "Shared/Loader/Loader";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";
import CallIcon from "@mui/icons-material/Call";

import styles from "./CustomerDetailsHeader.module.scss";

const handleOnClickPunchOrderButton = (
  navigate,
  uamId,
  selectedBusinessVertical
) => {
  return navigate(
    `/punchOrder?uamId=${uamId}&verticalId=${selectedBusinessVertical}`
  );
};

const CanPunchOrder = (orderDetails) => {
  if (!!orderDetails && orderDetails.length === 0) {
    return true;
  }
  const statusIds = orderDetails.map((order) => order.status.id);
  if (
    statusIds.some((statusId) =>
      [
        ORDER_STATUSES.ACCEPTED,
        ORDER_STATUSES.CANCELLATION_REQUESTED,
        ORDER_STATUSES.SUSPENDED,
      ].includes(statusId)
    )
  ) {
    return false;
  }
  return true;
};

const showCallCustomerButton = (orderDetails) => {
  return Array.isArray(orderDetails) && orderDetails.length > 0;
};

const handleClickCallButton = (
  uamId,
  callCustomer,
  openSnackbar
) => {
  callCustomer(
    {
      callee_uam_id: String(uamId)
    },
    {
      onSuccess: () => openSnackbar("Call Successful", "success"),
      onError: (error) => openSnackbar(`${error}`, "error"),
    }
  );
};

const CustomerDetailsHeader = (props) => {
  const { selectedBusinessVertical, uamId, orderDetails } = props;

  const navigate = useNavigate();
  const { openSnackbar } = useSnackbarContext();
  const { isPending: isCallCustomerLoading, mutate: callCustomer } =
    useCallCustomer();

  return (
    <div className={styles.customerDetailsContainer}>
      <div className={styles.customerInfoAndButtonContainer}>
        <div className={styles.customerIdAndBusinessVerticalDisplay}>
          <div className={styles.displayDetails}>
            <span className={styles.title}>Customer Id:</span>
            <span className={styles.value}>{uamId}</span>
          </div>
          <div className={styles.displayDetails}>
            <span className={styles.title}>Business Vertical:</span>
            <span className={styles.value}>
              {BUSINESS_VERTICAL[selectedBusinessVertical]}
            </span>
          </div>
        </div>

        <div className={styles.buttonsContainer}>
          {showCallCustomerButton(orderDetails) && (
            <SecondaryButton
              onClick={() =>
                handleClickCallButton(
                  uamId,
                  callCustomer,
                  openSnackbar
                )
              }
            >
              {isCallCustomerLoading ? (
                <Loader />
              ) : (
                <>
                  {" "}
                  <CallIcon />
                  Call Customer
                </>
              )}
            </SecondaryButton>
          )}
          {CanPunchOrder(orderDetails) && (
            <div className={styles.punchOrderButton}>
              <PrimaryButton
                onClick={() =>
                  handleOnClickPunchOrderButton(
                    navigate,
                    uamId,
                    selectedBusinessVertical
                  )
                }
              >
                Create Order
              </PrimaryButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerDetailsHeader;
